var boxShadow;

(function (boxShadow) {
  boxShadow["noShadow"] = "none";
  boxShadow["Default"] = "0 0 4px 0 rgba(34, 34, 34, 0.24)";
  boxShadow["Hover"] = "0 0 8px 0 rgba(34, 34, 34, 0.24)";
  boxShadow["Active"] = "0 0 16px 0 rgba(34, 34, 34, 0.24)";
})(boxShadow || (boxShadow = {}));

export default boxShadow;